import React, { FC, useState, useEffect, useCallback } from 'react'
import { useTheme, useMediaQuery } from '@material-ui/core'

import { PlayerProfileResponse } from 'protos'
import Layer from 'components/Layer'
import { Action } from 'types'

import PlayerProfile from './components/PlayerProfile'

type Props = {
  onClose: () => void
  getPlayerProfile: () => Promise<PlayerProfileResponse>
}

const PlayerLayer: FC<Props> = ({ onClose, getPlayerProfile }) => {
  const [{ result: playerProfile }, setPlayerProfile] = useState<Action<PlayerProfileResponse | null>>({ isLoading: false })
  const fetchPlayerProfile = useCallback(async () => {
    setPlayerProfile(playerProfile => ({ ...playerProfile, isLoading: true }))

    try {
      const result = await getPlayerProfile()
      setPlayerProfile(playerProfile => ({ ...playerProfile, isLoading: false, result }))
    } catch (err) {
      setPlayerProfile(playerProfile => ({ ...playerProfile, isLoading: false, errorCode: err.message }))
    }
  }, [getPlayerProfile])

  useEffect(() => { fetchPlayerProfile() }, [fetchPlayerProfile])

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

  if (!playerProfile) {
    return null
  }

  return (
    <Layer
      open
      maxWidth="sm"
      fullScreen={fullScreen}
      width={fullScreen ? '100%' : undefined}
      onClose={onClose}
    >
      <PlayerProfile
        onBackClick={onClose}
        playerProfile={playerProfile}
      />
    </Layer>
  )
}

export default PlayerLayer
try {
    // @ts-ignore
    PlayerLayer.displayName = "PlayerLayer";
    // @ts-ignore
    PlayerLayer.__docgenInfo = { "description": "", "displayName": "PlayerLayer", "props": { "onClose": { "defaultValue": null, "description": "", "name": "onClose", "required": true, "type": { "name": "() => void" } }, "getPlayerProfile": { "defaultValue": null, "description": "", "name": "getPlayerProfile", "required": true, "type": { "name": "() => Promise<any>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/PlayerLayer.tsx#PlayerLayer"] = { docgenInfo: PlayerLayer.__docgenInfo, name: "PlayerLayer", path: "src/components/PlayerLayer/PlayerLayer.tsx#PlayerLayer" };
}
catch (__react_docgen_typescript_loader_error) { }